import * as iots from 'io-ts';
export const logLevelsConfig = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
};
export const LogLevel = iots.keyof(logLevelsConfig);
//# sourceMappingURL=LogLevel.js.map